import React from 'react'
import { Link } from 'react-router-dom'
import './index.css'

const PurpleLink = ({
  linktext = 'Click here',
  classes = '',
  linkHolderStyles = {},
  linkStyles = {},
  to = '/',
  onClick = () => {},
  ...restProps
}) => {
  return (
    <div className="link-holder-purple" style={linkHolderStyles}>
      <Link
        linkStyles={linkStyles}
        onClick={onClick}
        to={to}
        linktext={linktext}
        className={classes}
        {...restProps}
      >
        {linktext}
      </Link>
    </div>
  )
}

export default PurpleLink
